import React from 'react';
import { Formik } from 'formik';
import { Modal } from '@oforce/global-components';

import { GraphQLErrors } from '../../../components';

import { FeeForm } from '.';
import { useEditFeeForm } from '../hooks';

export default function EditFee({ isOpen, toggle, product, fee }) {
  const { initialValues, validationSchema, handleSubmit, loading, error, reset } = useEditFeeForm({
    fee,
    product: product,
    onCompleted: toggle
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          title="Edit Fee"
          onSubmit={formik.handleSubmit}
          submitButtonDisabled={formik.isSubmitting}
          submitButtonProps={{ loadingText: 'Saving...' }}
          submitButtonText="Save Changes"
          loading={loading}
          onOpened={() => {
            reset();
            formik.handleReset();
          }}
        >
          <GraphQLErrors error={error} />
          <FeeForm fee={fee} product={product} formik={formik} />
        </Modal>
      )}
    </Formik>
  );
}
